import { ReactNode, createContext, useContext, useRef } from 'react';
import { MarketContextManager, MarketToaster } from '@market/react';

const MarketContext = createContext({
  toasterRef: null,
});

/*
  Hook to access the toasterRef from the MarketContext
 */
export const useMarketManagers = () => {
  return useContext(MarketContext);
};

interface MarketManagersProps {
  children: ReactNode;
}

/*
  Provides a component that wraps your app with
  market-context-manager and market-toaster for
  easier usage of market-toast, market-modal, etc.
  In order to use the toaster, you need to use `useToaster` from `typescript/hooks/use_toaster`
  In order to use any modals, follow the pattern lined out in go/marketstorybook
 */
export const MarketManagers = ({ children }: MarketManagersProps) => {
  const toasterRef = useRef<HTMLMarketToasterElement>(null);

  return (
    <MarketContext.Provider
      value={{
        toasterRef,
      }}
    >
      <MarketContextManager />
      <MarketToaster ref={toasterRef} />
      {children}
    </MarketContext.Provider>
  );
};
